ceregoCommon.factory('V3MyStudyItemsResource', ['$resource', ($resource) ->
  $resource "", {},
    query:
      method: 'GET'
      isArray: false
      url: APIRoutes.v3_my_study_items_path()
])
